import React from "react";
import { Car, Bluetooth } from "lucide-react";

/**
 * Informational card explaining how to listen to Madreterra TV in the car
 * via CarPlay / Android Auto / Bluetooth.
 */
export const CarHint = () => {
  return (
    <div
      data-testid="car-hint"
      className="relative overflow-hidden rounded-2xl border p-5 sm:p-6 flex items-start gap-4 sm:gap-5"
      style={{
        borderColor: "var(--mt-line)",
        background:
          "linear-gradient(135deg, rgba(20,17,13,0.7) 0%, rgba(28,24,19,0.55) 100%)",
        backdropFilter: "blur(14px)",
      }}
    >
      <div
        className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl flex items-center justify-center shrink-0"
        style={{
          background: "rgba(212,160,91,0.14)",
          color: "var(--mt-amber-bright)",
          border: "1px solid rgba(212,160,91,0.30)",
        }}
      >
        <Car size={26} strokeWidth={2} />
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1.5 flex-wrap">
          <h3
            className="font-display text-lg sm:text-xl leading-tight"
            style={{ color: "var(--mt-cream)" }}
          >
            In auto? MADRETERRA radio ti segue.
          </h3>
          <span
            className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] uppercase tracking-[0.22em] font-semibold"
            style={{
              background: "rgba(212,160,91,0.12)",
              color: "var(--mt-amber)",
              border: "1px solid rgba(212,160,91,0.30)",
            }}
          >
            <Bluetooth size={10} strokeWidth={2.6} />
            CarPlay · Android Auto · Bluetooth
          </span>
        </div>

        <p
          className="text-sm leading-relaxed"
          style={{ color: "var(--mt-text-muted)" }}
        >
          Apri MADRETERRA radio su iPhone o Android, collega il telefono
          all'auto: <span style={{ color: "var(--mt-cream)" }}>titolo,
          copertina e comandi</span> appaiono automaticamente sul cruscotto.
          I tasti play, pausa e volume del volante funzionano subito —
          niente da installare.
        </p>
      </div>

      {/* decorative road glow */}
      <div
        aria-hidden="true"
        className="absolute -right-10 -bottom-10 w-40 h-40 rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(212,160,91,0.18) 0%, transparent 70%)",
        }}
      />
    </div>
  );
};

export default CarHint;
